import * as React from "react";
import { IOpLabelValue } from "../../../../types/components/orderPlacement/opTypes";
import { range } from "./../../../../service/rangeGen";

export interface IOpMarketDepthListProps {
	data: Array<IOpLabelValue>;
}

const OpMarketDepthList: React.FC<IOpMarketDepthListProps> = props => {
	return (
		<div className="op_quotes_mf_nfo_content">
			{props.data.map(d => (
				<div className="row" key={d.label}>
					<span className="label ib">{d.label}</span>
					{d.label === "MorningStar Rating" ? (
						<span className="star ib">
							{range(5).map(index => (
								<i key={index} className={"edel-icon-star" + (index < d.value ? " yellow" : " grey")} />
							))}
						</span>
					) : (
						<span className="value ib">{d.value}</span>
					)}
				</div>
			))}
		</div>
	);
};

export default OpMarketDepthList;
